var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3379 29.7208V13.7752C33.3379 11.4346 31.2634 9.52963 28.7118 9.52963H27.4444V9.27491C27.4444 6.93343 25.3699 5.0293 22.8184 5.0293H21.1098H11.318H9.2662C6.71539 5.0293 4.64014 6.93343 4.64014 9.27491V25.2204C4.64014 27.5611 6.71547 29.466 9.2662 29.466H10.5334V29.7208C10.5334 32.0622 12.6088 33.9664 15.1596 33.9664H17.2114H27.0032H27.8834H28.7118C31.2634 33.9664 33.3379 32.0623 33.3379 29.7208ZM27.0032 32.5767H17.2114H15.1596C13.4404 32.5767 12.0474 31.2981 12.0474 29.7208V29.466V28.0762V13.7752C12.0474 12.198 13.4404 10.9194 15.1596 10.9194H17.2114H25.9306H27.0032H27.4444H28.7118C30.431 10.9194 31.8239 12.198 31.8239 13.7752V29.7208C31.8239 31.2981 30.431 32.5767 28.7118 32.5767H27.8834H27.0032Z",
    fill: "black",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6425 16.454H26.684C27.0166 16.454 27.286 16.1846 27.286 15.8519C27.286 15.5193 27.0166 15.25 26.684 15.25H14.6425C14.3099 15.25 14.0405 15.5193 14.0405 15.8519C14.0405 16.1846 14.3099 16.454 14.6425 16.454Z",
    fill: "black",
    fillOpacity: 0.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5449 19.9427C16.5449 20.2753 16.8151 20.5446 17.1477 20.5446H28.4314C28.7641 20.5446 29.0342 20.2753 29.0342 19.9427C29.0342 19.6101 28.7641 19.3398 28.4314 19.3398H17.1477C16.8151 19.3398 16.5449 19.61 16.5449 19.9427Z",
    fill: "black",
    fillOpacity: 0.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.82 24.0317C25.82 23.6991 25.5506 23.4297 25.218 23.4297H14.6425C14.3099 23.4297 14.0405 23.6991 14.0405 24.0317C14.0405 24.3643 14.3099 24.6345 14.6425 24.6345H25.218C25.5506 24.6345 25.82 24.3644 25.82 24.0317Z",
    fill: "black",
    fillOpacity: 0.65
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.034 28.1215C29.034 27.7889 28.7638 27.5195 28.4312 27.5195H18.521C18.1884 27.5195 17.9189 27.7889 17.9189 28.1215C17.9189 28.4541 18.1883 28.7235 18.521 28.7235H28.4312C28.7639 28.7235 29.034 28.4541 29.034 28.1215Z",
    fill: "black",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/editDark.dc36d7ed5687a4a3a3dbca6baba2e7dd.svg";
export { ForwardRef as ReactComponent };